class Transitions
{
    constructor()
    {
        this.match = gsap.matchMedia();
        this.init();
    }

    init()
    {
        this.match.add("(min-width: 768px)", () =>
        {
            if(document.querySelector(".row-contact > div:first-child")) {

                let headerHeight = document.querySelector("header").offsetHeight + 30 + document.querySelector(".header-search-form").offsetHeight;
                let blocHeight = document.querySelector(".row-contact > div:first-child").offsetHeight;
                ScrollTrigger.create({
                    trigger: ".row-contact > div:first-child",
                    start: "top " + headerHeight + "px", 
                    endTrigger: ".row-contact > div:last-child",
                    end: "bottom " + blocHeight + "px", 
                    pin: true,
                });
            }

            if(document.querySelector(".header-search-form")) {
                gsap.set(".header-search-form .search-form-container", {alpha:1, y:"-100%"});
                gsap.to(".header-search-form .search-form-container", {duration:0.7, y:0, ease:"power3.out", scrollTrigger:
                {
                    trigger: ".main-container > div:first-child",
                    start: "top top",
                    toggleActions: "play none none reverse" // onEnter, onLeave, onEnterBack, onLeaveBack
                }});
            }
        });
        
        
        if(document.querySelector(".row-nos-projets")) {
            let projets = gsap.utils.toArray(".projets-container .projet");
            projets.forEach(projet =>
            {
                projet.addEventListener("mouseenter", (e) =>
                {
                    if(e.currentTarget.classList.contains("empty") || window.innerWidth <= 768) {return;}
                    gsap.set(e.currentTarget.querySelector(".projet-description"), {y:10});
                    gsap.to(e.currentTarget.querySelector(".projet-logo"), {y:0, duration:0.8, ease:"expo.out"});
                    gsap.to(e.currentTarget.querySelector(".projet-description"), {delay:0.1, y:0, opacity:1, duration:0.7, ease:"power3.out"});
                    gsap.to(e.currentTarget.querySelector(".projet-infos-bg"), {opacity:1, duration:0.6, ease:"power3.out"});
                });

                projet.addEventListener("mouseleave", (e) =>
                {
                    if(e.currentTarget.classList.contains("empty") || window.innerWidth <= 768) {return;}
                    let logo = e.currentTarget.querySelector(".projet-logo");
                    let logoY = logo.offsetTop;
                    let centerParent = e.currentTarget.offsetHeight/2 - logo.offsetHeight/2;
                    let depY = centerParent - logoY;
                    gsap.to(e.currentTarget.querySelector(".projet-logo"), {delay:0.05, y:depY, duration:0.6, ease:"power3.out", overwrite:true});
                    gsap.to(e.currentTarget.querySelector(".projet-description"), {opacity:0, y:10, duration:0.4, ease:"power3.out", overwrite:true});
                    gsap.to(e.currentTarget.querySelector(".projet-infos-bg"), {opacity:0, duration:0.4, ease:"power3.out", overwrite:true});
                });
            });
        }

        window.addEventListener("resize", this.resizeHandler);
	    this.resizeHandler();
        
        //Ajouter la classe text-top aux éléments pour un fondu avec petit mouvement vers le haut
        this.setupTextTop(".text-top");

        // Ajouter la classe fade-in aux éléments pour un fondu
        let fades = gsap.utils.toArray(".fade-in");
        fades.forEach(fade =>
        {
            let d = 0;
            if(fade.classList.contains("delay-1")) {d = 0.1;}
            if(fade.classList.contains("delay-2")) {d = 0.2;}
            if(fade.classList.contains("delay-3")) {d = 0.3;}
            if(fade.classList.contains("delay-4")) {d = 0.4;}

            gsap.from(fade, {
                autoAlpha:0,
                duration:1.5,
                delay:d,
                ease:"power3.out",
                scrollTrigger: {
                    trigger:fade,
                    start:"top 90%",
                    toggleActions: "play none play none"
                }
            });
        });

        // Pour un dévoilement graduel lettre par lettre
        // let quotes = document.querySelectorAll(".split-text");
        // quotes.forEach(quote =>
        // {
        //     if(quote.anim) {
        //         quote.anim.progress(1).kill();
        //         quote.split.revert();
        //     }
    
        //     quote.split = new SplitText(quote, {type: "words,chars"});
    
        //     quote.anim = gsap.from(quote.split.chars, {
        //         scrollTrigger: {
        //             trigger: quote,
        //             toggleActions: "restart pause resume reverse",
        //             start: "top 75%",
        //             end: "bottom 80%",
        //             scrub:1,
        //         },
        //         duration:0.001,
        //         css:{color:"#2b4065"},
        //         css:{opacity:0.2},
        //         stagger: 0.05,
        //     });
        // });
    }

    setupTextTop(selector)
    {
        //Ajouter la classe text-top aux éléments pour un fondu avec petit mouvement vers le haut
        let textsTop = gsap.utils.toArray(selector);
        textsTop.forEach(textTop =>
        {
            let d = 0;
            if(textTop.classList.contains("delay-1")) {d = 0.1;}
            if(textTop.classList.contains("delay-2")) {d = 0.2;}
            if(textTop.classList.contains("delay-3")) {d = 0.3;}
            if(textTop.classList.contains("delay-4")) {d = 0.4;}
            if(textTop.classList.contains("delay-5")) {d = 0.5;}
            if(textTop.classList.contains("delay-6")) {d = 0.6;}

            gsap.from(textTop, {
                autoAlpha:0,
                duration:1,
                y:20,
                ease:"power3.out",
                delay:d,
                scrollTrigger: {
                    trigger:textTop,
                    start:"top 90%",
                    toggleActions: "play none play none"
                }
            });
        });

        window.dispatchEvent(new Event('resize'));
    }

    resizeHandler(e)
    {
        if(document.querySelector(".row-nos-projets")) {
            let projets = gsap.utils.toArray(".projets-container .projet");
            projets.forEach(projet =>
            {
                let logo = projet.querySelector(".projet-logo");
                if(logo) {
                    let logoY = logo.offsetTop;
                    let centerParent = projet.offsetHeight/2 - logo.offsetHeight/2;
                    let depY = centerParent - logoY;
                    
                    if(window.innerWidth < 768) {
                        logoY = logo.offsetTop;
                        centerParent = projet.querySelector(".projet-img").offsetHeight/2 + logo.offsetHeight/2;
                        depY = -logoY - centerParent;
                    }

                    gsap.set(logo, {y:depY});
                }
            });
        }
    }
}

export default Transitions;